import { render, staticRenderFns } from "./viewPMR.vue?vue&type=template&id=000d6bf6&scoped=true&"
import script from "./viewPMR.vue?vue&type=script&lang=js&"
export * from "./viewPMR.vue?vue&type=script&lang=js&"
import style0 from "./viewPMR.vue?vue&type=style&index=0&id=000d6bf6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000d6bf6",
  null
  
)

export default component.exports